import { useState, useCallback } from 'react'

import { ConfirmPanel } from '@/forms-legacy'

import { Actions } from './Actions'
import { useActions } from './hooks/useActions'
import { useTexts } from './hooks/useTexts'

interface Props {
  alert: uui.domain.client.gps.wwgps.EventAlert
}

export function ActionsManager(props: Props) {
  const { alert } = props

  const [view, setView] = useState<'delete' | 'default'>('default')

  const actions = useActions(alert.id)
  const texts = useTexts()

  const onSwitchToDelete = useCallback(() => {
    setView('delete')
  }, [])

  const onSwitchToDefault = useCallback(() => {
    setView('default')
  }, [])

  switch (view) {
    case 'delete':
      return (
        <ConfirmPanel
          title={texts.title}
          description={texts.subtitle}
          confirmationText={texts.delete}
          onCancel={onSwitchToDefault}
          onConfirm={actions.onDeleteAlert}
        />
      )

    case 'default':
      return <Actions onDelete={onSwitchToDelete} onEdit={actions.onStartEdit} />
  }
}
